import { render, staticRenderFns } from "./OtaruSearchDestroyItemDialog.vue?vue&type=template&id=6fbc7fc6&scoped=true&"
import script from "./OtaruSearchDestroyItemDialog.vue?vue&type=script&lang=ts&"
export * from "./OtaruSearchDestroyItemDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OtaruSearchDestroyItemDialog.vue?vue&type=style&index=0&id=6fbc7fc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc7fc6",
  null
  
)

export default component.exports